import {Component, OnInit, ViewChild} from '@angular/core';
import { MatSort} from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import {Ordered} from '../models/ordered';
import {Product} from '../models/product';
import {ProductService} from '../services/product.service';
import {TransferService} from '../services/transfer.service';
import {ConfirmComponent} from '../shared/dialogs/confirm/confirm.component';
import {TransferDialogComponent} from './dialogs/transfer-dialog/transfer-dialog.component';

@Component({
  selector: 'app-transfer',
  templateUrl: './transfer.component.html',
  styleUrls: ['./transfer.component.scss']
})
export class TransferComponent implements OnInit {

  @ViewChild(MatSort, {static: true}) sort: MatSort;

  public displayedColumns: string[] = ['icon', 'date_buy', 'member', 'category', 'total', 'date_received', 'edit', 'delete'];

  public products: Product[] = []
  public selectedProduct: any = {};
  public dataSource: MatTableDataSource<any>;

  constructor (
    private dialog: MatDialog,
    private _productService: ProductService,
    private _transferService: TransferService
  ) {
    this.loadProducts()
  }

  ngOnInit () {
  }


  selectByProduct (event) {
    let product_id = event
    this._transferService.loadTransfers(product_id)
      .subscribe((result) => {

        let array: any[] = []

        result.forEach((item) => {
          let dt: any = item.payload.doc.data().date
          array.push({
            "id": item.payload.doc.id,
            'date': dt.toDate(),
            'payment_type': item.payload.doc.data().payment_type,
            'payment_date': item.payload.doc.data().payment_date,
            'returnCode': item.payload.doc.data().returnCode,
            'member_name': item.payload.doc.data().member_name,
            'member_id': item.payload.doc.data().member_id,
            'product_name': item.payload.doc.data().product_name,
            'product_id': item.payload.doc.data().product_id,
            'category_name': item.payload.doc.data().category_name,
            'category_id': item.payload.doc.data().category_id,
            'origin': item.payload.doc.data().origin,
            'total': item.payload.doc.data().total,
          })
        })

        this.dataSource = new MatTableDataSource(array);
        this.dataSource.sort = this.sort;

        this.dataSource.sortingDataAccessor = (item, property) => {
          if (property === 'date_buy') {
            return item.date;
          } else {
            return item[ property ];
          }
        };

        this.dataSource.sortingDataAccessor = (item, property) => {
          if (property === 'member') {
            return item.member_name;
          } else {
            return item[ property ];
          }
        };



      })

  }

  loadProducts () {

    return this._productService.selectProducts()
      .subscribe((result) => {

        result.forEach((item) => {
          let product = new Product();
          product.id = item.payload.doc.id;
          product.name = item.payload.doc.data().name;
          product.text = item.payload.doc.data().text;
          product.image = item.payload.doc.data().image;
          product.active = item.payload.doc.data().active;
          this.products.push(product)
        })

      })
  }

  openDialog (entity) {

    let data: Ordered = new Ordered();

    if (entity) {
      data = entity;
    }

    this.dialog.open(TransferDialogComponent, {
      width: '600px',
      height: '460px',
      panelClass: 'custom-dialog-container',
      data: data
    });
  }

  cancelTransfer(element){
   
    let dialogRef = this.dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: { title: "Confirme", message: element.member_name + "<br>" + element.product_name + "<br><br>Cancelar esta transferência?" }
    });
    dialogRef.afterClosed().subscribe(result => {

      if (result == "ok") {

        this._transferService.cancelTransfer(element.id)

      }

    })
    
  }


}

